export const PROCEED_EVENT_NAME = 'proceed'
export const DEFAULT_TITLE_KEY = 'name'
export const DEFAULT_VALUE_KEY = 'id'
export const DEFAULT_SEARCH_KEY = 'searchString'
